var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorona(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20a10 10 0 010-20v20zM10 20a10 10 0 000-20v20z",
    fill: "#FD9F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20a10 10 0 000-20v2.407a7.594 7.594 0 010 15.186V20zM10 20a10 10 0 010-20v2.407a7.593 7.593 0 100 15.186V20z",
    fill: "#FED330"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.062 6.618l.573 5.835a1 1 0 00.995.902H10v-8.06L7.754 8.593 5.396 6.45a.2.2 0 00-.334.168zM14.938 6.615l-.574 5.838a1 1 0 01-.995.902H10v-8.06l2.234 3.293 2.372-2.14a.2.2 0 01.333.167z",
    fill: "#FED330"
  })));
}
export default SvgCorona;